interface E2EAgentFrontendFeatureFlags {
  hideChatAndFastTrack?: boolean;
  hideRunInputTypeColumn?: boolean;
  hideRunVersionColumn?: boolean;
  hideRunModelColumns?: boolean;
  showRunTimeoutColumn?: boolean;
  showRunStartDateColumn?: boolean;
}

declare global {
  interface Window {
    __E2E_AGENT_FRONTEND_FEATURE_FLAGS__?: E2EAgentFrontendFeatureFlags;
  }
}

export function hideChatAndFastTrack(): boolean {
  if (typeof window !== "undefined") {
    const runtimeValue =
      window.__E2E_AGENT_FRONTEND_FEATURE_FLAGS__?.hideChatAndFastTrack;
    if (typeof runtimeValue === "boolean") return runtimeValue;
  }

  return import.meta.env.VITE_HIDE_CHAT_AND_FAST_TRACK === "true";
}

export function hideRunInputTypeColumn(): boolean {
  if (typeof window !== "undefined") {
    const runtimeValue =
      window.__E2E_AGENT_FRONTEND_FEATURE_FLAGS__?.hideRunInputTypeColumn;
    if (typeof runtimeValue === "boolean") return runtimeValue;
  }

  return import.meta.env.VITE_HIDE_RUN_INPUT_TYPE_COLUMN === "true";
}

export function hideRunVersionColumn(): boolean {
  if (typeof window !== "undefined") {
    const runtimeValue =
      window.__E2E_AGENT_FRONTEND_FEATURE_FLAGS__?.hideRunVersionColumn;
    if (typeof runtimeValue === "boolean") return runtimeValue;
  }

  return import.meta.env.VITE_HIDE_RUN_VERSION_COLUMN === "true";
}

export function hideRunModelColumns(): boolean {
  if (typeof window !== "undefined") {
    const runtimeValue =
      window.__E2E_AGENT_FRONTEND_FEATURE_FLAGS__?.hideRunModelColumns;
    if (typeof runtimeValue === "boolean") return runtimeValue;
  }

  return import.meta.env.VITE_HIDE_RUN_MODEL_COLUMNS === "true";
}

export function showRunTimeoutColumn(): boolean {
  if (typeof window !== "undefined") {
    const runtimeValue =
      window.__E2E_AGENT_FRONTEND_FEATURE_FLAGS__?.showRunTimeoutColumn;
    if (typeof runtimeValue === "boolean") return runtimeValue;
  }

  return import.meta.env.VITE_SHOW_RUN_TIMEOUT_COLUMN === "true";
}

export function showRunStartDateColumn(): boolean {
  if (typeof window !== "undefined") {
    const runtimeValue =
      window.__E2E_AGENT_FRONTEND_FEATURE_FLAGS__?.showRunStartDateColumn;
    if (typeof runtimeValue === "boolean") return runtimeValue;
  }

  return import.meta.env.VITE_SHOW_RUN_START_DATE_COLUMN === "true";
}
